// extracted by mini-css-extract-plugin
export default {"zoomModal":"n0-z"};